<template>
  <div class="key-container">
    <div
      v-if="labelUpper"
      :id="labelledBy === 'upper' ? `key-${id}-label` : ''"
      class="key-container__label key-container__label--upper"
    >
      {{ labelUpper }}
    </div>
    <button
      ref="key"
      class="key"
      :class="classes"
      :aria-labelledby="labelledBy ? `key-${id}-label` : ''"
      @click="handleClick"
    >
      <span class="key__face"></span>
    </button>
    <div
      v-if="labelLower"
      :id="labelledBy === 'lower' ? `key-${id}-label` : ''"
      class="key-container__label key-container__label--lower"
    >
      {{ labelLower }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Key',
  props: {
    id: {
      type: String,
      required: true,
    },
    idx: {
      type: Number,
      required: false,
    },
    emitEvent: {
      type: String,
      required: true,
    },
    labelledBy: {
      type: String,
      required: true,
    },
    labelUpper: {
      type: String,
      required: false,
    },
    labelLower: {
      type: String,
      required: false,
    },
    isLight: {
      type: Boolean,
      required: false,
    },
    isActive: {
      type: Boolean,
      required: false,
    },
    isPressed: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    classes() {
      return {
        'key--light': this.isLight,
        'key--active': this.isActive,
        'key--pressed': this.isPressed,
      }
    },
  },
  mounted() {
    // Trigger iOS Safari button active state (https://stackoverflow.com/a/33681490)
    this.$refs.key.addEventListener('touchstart', () => {}, { passive: true })
  },
  methods: {
    handleClick() {
      this.$emit(this.emitEvent, this.idx, this.id)
    },
  },
}
</script>
